import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

import { Grid, Row, Col } from '../../ui/Grid';

import {
  updateGenomicRange,
  updateGenomicRangeWithPosition,
} from '../../../actions/GenomeActions';

import styles from './ASDBrowserPage.css'; // eslint-disable-line
import Link from '../../Link';
import VariantFeatureBrowser from '../../genome/VariantFeatureBrowser';

const TRACK_STYLE = {
  type: 'default',
  style: {
    glyph: 'HISTOGRAM',
    BGCOLOR: '#105CC9',
    HEIGHT: 50,
    MIN: 0,
    MAX: 3,
  },
};

const ASD_DEEPSEA_MODELS = [
  {
    name: 'DNA_Binding',
    label: 'DNA features',
    level: 'FEATURE',
    range: [-3, 0, 3],
    track: {
      name: 'DNA Disease Impact Score',
      bwgURI: 'https://s3-us-west-2.amazonaws.com/humanbase/tracks/dis_dna.bw',
      pinned: true,
      style: [TRACK_STYLE],
    },
  },
  {
    name: 'RNA_Binding',
    label: 'RNA features',
    level: 'FEATURE',
    range: [-3, 0, 3],
    track: {
      name: 'RNA Disease Impact Score',
      bwgURI: 'https://s3-us-west-2.amazonaws.com/humanbase/tracks/dis_rna.bw',
      pinned: true,
      style: [TRACK_STYLE],
    },
  },
];

const TRACKS = ASD_DEEPSEA_MODELS.map(model => model.track);

class ASDBrowserPage extends Component {
  static propTypes = {
    chr: PropTypes.string,
    startPosition: PropTypes.number,
    endPosition: PropTypes.number,
    gene: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    gene: null,
    chr: null,
    startPosition: null,
    endPosition: null,
  };

  componentDidMount() {
    const { chr, startPosition, endPosition, dispatch } = this.props;
    if (chr && startPosition && endPosition) {
      dispatch(updateGenomicRange(chr, startPosition, endPosition));
    } else if (chr && startPosition) {
      dispatch(updateGenomicRangeWithPosition(chr, startPosition));
    }
  }

  onFeatureInfo = (feature, info) => {
    const trackName = info.tier.dasSource.name;
    info.setTitle(trackName);
    if (trackName === TRACKS[0].name) {
      const div = document.createElement('a');
      div.setAttribute('href', `/expecto/${feature.segment}:${feature.min}`);
      div.appendChild(document.createTextNode('View in ExPecto'));
      info.sections.push({ label: 'ExPecto', info: div });
    }
  };

  render() {
    const { gene } = this.props;
    return (
      <Grid fluid={false}>
        <Row>
          <Col md={12}>
            <div className={styles.container}>
              <div
                style={{ width: '80%', margin: 'auto', textAlign: 'center' }}
              >
                <h3 className={styles.title}>
                  Whole-genome deep learning analysis reveals causal role of
                  noncoding mutations in autism
                </h3>
                <p>
                  Explore the predicted effects of 127,140 autism proband
                  mutations from Simons Simplex Collection whole genome
                  sequencing data.
                </p>
                <p>
                  <Link to="/dis_asd">View as table</Link>
                </p>
              </div>
              <VariantFeatureBrowser
                models={ASD_DEEPSEA_MODELS}
                sources={TRACKS}
                onFeatureInfo={this.onFeatureInfo}
                gene={gene}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect()(withStyles(styles)(ASDBrowserPage));
